import type { ReactNode } from 'react';
import { ApiError } from '../../lib/api';
import type { InternalCorrectionStatus } from '../../lib/moderationApi';

export const inputClass =
  'w-full rounded-md border border-border bg-background px-3 py-2 text-sm text-foreground outline-none transition focus:border-primary focus:ring-2 focus:ring-primary/20';
export const buttonClass =
  'inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground transition hover:bg-primary/90 disabled:cursor-not-allowed disabled:opacity-60';
export const secondaryButtonClass =
  'inline-flex items-center justify-center rounded-md border border-border bg-card px-4 py-2 text-sm font-semibold transition hover:border-primary hover:text-primary disabled:cursor-not-allowed disabled:opacity-60';

export const statusLabels: Record<InternalCorrectionStatus, string> = {
  SUBMITTED: 'Ожидает первого ревью',
  AWAITING_SECOND_REVIEW: 'Ожидает второго ревью',
  APPROVED_AWAITING_RECALC: 'Одобрена, ожидает пересчёта',
  REJECTED: 'Отказано',
  DISPUTED: 'Спорная заявка',
};

const statusClasses: Partial<Record<InternalCorrectionStatus, string>> = {
  AWAITING_SECOND_REVIEW:
    'border-amber-400/70 bg-amber-100 text-amber-950 dark:border-amber-500/60 dark:bg-amber-950/60 dark:text-amber-100',
};

export function StatusBadge({ status }: { status: InternalCorrectionStatus }): JSX.Element {
  return (
    <span
      className={`inline-flex rounded-full border px-2.5 py-1 text-xs font-semibold ${
        statusClasses[status] ?? 'border-border bg-muted/50'
      }`}
    >
      {statusLabels[status]}
    </span>
  );
}

export function ErrorMessage({ error }: { error: unknown }): JSX.Element {
  const message =
    error instanceof ApiError
      ? error.status === 409
        ? 'Состояние заявки изменилось. Обновите данные и повторите действие.'
        : error.status === 429
          ? 'Слишком много запросов. Подождите и повторите попытку.'
          : error.message
      : 'Не удалось выполнить запрос.';
  return (
    <div role="alert" className="rounded-md border border-destructive/40 bg-destructive/10 p-3 text-sm">
      {message}
    </div>
  );
}

export function Section({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}): JSX.Element {
  return (
    <section className="rounded-lg border border-border bg-card p-4 sm:p-5">
      <h2 className="mb-4 text-lg font-semibold">{title}</h2>
      {children}
    </section>
  );
}
